import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import {
  IActivateFreePlan,
  IActivatedFreePlan,
  IArriveBilling,
  IGreeting,
  IStatusForPlanActivate,
  ISubscriptionDetails,
} from "@/types/stateTypes";

export const usePlanActivate = create(
  persist<IStatusForPlanActivate>(
    (set) => ({
      statusPlanActivate: true,
      setPlanActivateStatus: (val) => {
        set({
          statusPlanActivate: val,
        });
      },
      destroyStatusPlanActivate: () => {
        set((state) => {
          return {
            ...state,
            statusPlanActivate: false,
          };
        });
      },
    }),
    {
      name: "useStatusPlanActivate",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useSubscriptionDetails = create(
  persist<ISubscriptionDetails>(
    (set) => ({
      isSubscriptionDetails: null,
      currencyType: {
        icon: "$",
        value: "USD",
      },
      setIsSubscriptionDetails: (val) => {
        set((state) => ({
          ...state,
          isSubscriptionDetails: { ...state.isSubscriptionDetails, ...val },
        }));
      },
      setIsCurrencyType: (val) => {
        set({
          currencyType: val,
        });
      },
    }),
    {
      name: "useSubscriptionDetail",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useActivateFreePlan = create<IActivateFreePlan>((set) => ({
  show: false,
  setShow: (val) => {
    set({
      show: val,
    });
  },
}));

export const useGreeting = create<IGreeting>((set) => ({
  greeting: false,
  setGreeting: (val) => {
    set({
      greeting: val,
    });
  },
  destroyGreeting: () => {
    set((state) => {
      return {
        ...state,
        greeting: false,
      };
    });
  },
}));

export const useActivateFreePlanSuccess = create<IActivatedFreePlan>((set) => ({
  activatedSuccessfully: false,
  setActivatedSuccessfully: (val) => {
    set({
      activatedSuccessfully: val,
    });
  },
  destroyActivatedSuccessfully: () => {
    set((state) => {
      return {
        ...state,
        activatedSuccessfully: false,
      };
    });
  },
}));

export const useArriveBilling = create(
  persist<IArriveBilling>(
    (set) => ({
      isArriveBilling: false,
      setIsArriveBilling: (val) => set({ isArriveBilling: val }),
      clean: () => {
        set({ isArriveBilling: false });
      },
    }),
    {
      name: "useArriveBilling",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
